import React from "react";

import MuiBox from "@mui/material/Box";

const SELF_CLOSING_TAGS = [
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
];

function normalizeSx(sx: any) {
    if (!sx || typeof sx !== "object" || Array.isArray(sx)) return sx;
    const next = { ...sx };

    if (next.bgColor !== undefined && next.bgcolor === undefined) {
        next.bgcolor = next.bgColor;
        delete next.bgColor;
    }

    return next;
}

export const Box = ({ component = "div", children, ...props }: any) => {
    props = {
        ...props,
        sx: normalizeSx(props?.sx),
    };

    // ✅ self-closing html tags
    if (
        typeof component === "string" &&
        SELF_CLOSING_TAGS.includes(component)
    ) {
        return (
            <MuiBox
                component={component}
                {...props}
            />
        );
    }

    if(props?.debug)debug('{sx}', props?.sx);
    return (
        <MuiBox
            component={component}
            {...props}
        >
            {children}
        </MuiBox>
    );
};

export default Box;
